"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styledLayout_1 = require("../base/styledLayout");
var formContext_1 = require("./context/formContext");
var FormComponent = function (_a) {
    var children = _a.children, onSubmit = _a.onSubmit, form = _a.form, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _form = form;
    if (!form) {
        _form = React.useContext(formContext_1.FormContext);
    }
    var _onSubmit = function (e) {
        e.preventDefault();
        _form.submit(function (form, state) { return onSubmit(form, state, e); });
    };
    var formClassName = classnames_1.default('ty-form', className);
    return (React.createElement(styledLayout_1.StyledLayout, { elementType: "form" /* Form */, onSubmit: _onSubmit, className: formClassName }, children));
};
exports.Form = function (props) {
    var form = React.useContext(formContext_1.FormContext);
    return form.hasProvider ? (React.createElement(FormComponent, __assign({}, props, { form: form }))) : (React.createElement(formContext_1.FormProvider, __assign({}, props),
        React.createElement(FormComponent, __assign({}, props))));
};
